<template>
    <span v-text="formattedTime" />
</template>

<script lang="ts" setup>
import { computed, onMounted, reactive } from 'vue';
import { useReservationTime } from '../modules/useReservationTime';

const { reservationTimeState, startCounter, stopCounter } = useReservationTime();

const props = defineProps({
    modelValue: Boolean,
});

const emit = defineEmits({
    'update:modelValue': () => true,
});

const format = (value: number) => (`0${value}`).slice(-2);

const formattedTime = computed(() => {
    if (!reservationTimeState.timeUntilReservationEnds) {
        return null;
    }

    return (reservationTimeState.timeUntilReservationEnds < 0)
        ? ('00:00')
        : (`${format(Math.floor((reservationTimeState.timeUntilReservationEnds / 60)))}:${format(reservationTimeState.timeUntilReservationEnds % 60)}`);
});

const stopCount = () => {
    stopCounter();
    emit('update:modelValue');
};

const startCount = () => {
    startCounter();
};

onMounted(() => {
    if (!reservationTimeState.timeUntilReservationEnds || reservationTimeState.timeUntilReservationEnds < 1) return stopCount();

    startCount();
});
</script>
